<nav class="nav-bar">
  <div class="nav-inner u-flex-row">
    <a
      [href]="'url.anthemMedicaid' | translate"
      target="_blank"
      rel="noopener noreferrer"
      class="nav-logo">
      <img [src]="assets.images.anthemLogoBlue" alt="Anthem logo" />
    </a>
    <div class="nav-center"></div>
    <div class="nav-controls u-flex-row">
      <app-font-size-picker (fontSizeChange)="handleFontSizeChange($event)"></app-font-size-picker>
      <app-language-dropdown [locale]="locale" (languageChange)="handleLanguageChange($event)">
      </app-language-dropdown>
    </div>
  </div>
</nav>
